export default __webpack_public_path__ + "static/media/biochemistry.e9106640.png";